import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import focusable from '../../components/Focusable/Focusable'
import tts from '../../lib/TTS'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

class StdButton extends React.PureComponent {
  constructor(props) {
    super(props)
    this.componentType = this.props.componentType
    this.buttonRef = React.createRef()
  }

  onFocus() {
    if ('function' === typeof this.props.onFocus) {
      this.props.onFocus({
        tts: `Focused on ${this.props.label}.`,
      })
      if (!this.props.preventReadTextOnFocus) {
        tts.stopRead()
      }
    }
  }

  onKeyEvent(key) {
    let handled = false

    if (this.props.disabled) {
      return false
    }

    if (key === 'ENTER' && true === this.props.link && this.buttonRef.current) {
      this.buttonRef.current?.click()
      // our callback for std button in upNext
      this.readTextOnEvent(
        this.props.label ? `Selected ${this.props.label}` : `Button Pressed`
      )
      if (this.props.upNext) {
        this.props.handleUpNextClick()
      }
      handled = true
    } else if (key === 'ENTER' && 'function' === typeof this.props.onClick) {
      this.props.onClick()

      this.readTextOnEvent(
        this.props.label ? `Selected ${this.props.label}` : `Button Pressed`
      )

      handled = true
    } else if (key === 'ENTER') {
      if (this.props.router.location.pathname !== '/change-station') {
        this.readTextOnEvent(
          this.props.label ? `Selected ${this.props.label}` : `Button Pressed`
        )
      }
    }

    return handled
  }

  buttonInternals() {
    const { children, to, link, hasFocus } = this.props

    if (true === link) {
      return (
        <Link
          to={to}
          ref={this.buttonRef}
          className={`link ${hasFocus ? 'active' : 'inactive'}`}
        >
          {children}
        </Link>
      )
    } else {
      return <span ref={this.buttonRef}>{children}</span>
    }
  }

  readText = () => {
    if (!this.props.preventReadTextOnFocus) {
      tts.addTextToRead(`Focused on ${this.props.label}.`)
    }
  }

  readTextOnEvent = (textToReadInEvent) => {
    if (!this.props.preventReadTextOnEvent) {
      tts.pushTextToRead(textToReadInEvent)
    }
  }

  render() {
    const { label, hasFocus, hasLogo, id, isSelected } = this.props

    return (
      <span
        id={id}
        style={{
          display: this.props.visible === false ? 'none' : 'inline-flex',
        }}
        className={`button-container ${
          hasLogo
            ? 'container-style'
            : hasLogo === undefined
            ? ''
            : 'no-logo-container-style'
        } ${isSelected ? 'buttonSelected' : 'buttonInactive'}
          ${hasFocus ? 'focused' : ''}`}
      >
        <button className={`button ${hasFocus ? 'active' : 'inactive'}`}>
          {this.buttonInternals()}
        </button>

        {label && (
          <span className={`label ${hasFocus ? 'active' : 'inactive'}`}>
            {label}
          </span>
        )}
      </span>
    )
  }
}

StdButton.propTypes = {
  className: PropTypes.string,
  //children can be string, array, or element - use union type
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]),
  componentType: PropTypes.string,
  preventReadTextOnFocus: PropTypes.bool,
  preventReadTextOnEvent: PropTypes.bool,
  containerStyle: PropTypes.object,
  disabled: PropTypes.bool,
  hasFocus: PropTypes.bool,
  hasLogo: PropTypes.bool,
  isSelected: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  link: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  to: PropTypes.string,
  tts: PropTypes.string,
  upNext: PropTypes.bool,
  visible: PropTypes.bool,
  handleUpNextClick: PropTypes.func,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
}

export default withRouter(focusable(StdButton))
